type ErrorShaped = { name: string; message: string };

// Duck-typed instead of `instanceof Error`: an exception raised in another window's
// realm (e.g. a <video> adopted into a Document Picture-in-Picture window) fails this
// realm's instanceof check but still carries the standard name/message fields.
// Deliberately narrower than serialize-error's `isErrorLike`, which also requires a
// string `stack` — DOMExceptions are not guaranteed to have one.
export const isErrorShaped = (error: unknown): error is ErrorShaped => {
  if (typeof error !== 'object' || error === null) {
    return false;
  }

  const { name, message } = error as { name?: unknown; message?: unknown };

  return typeof name === 'string' && typeof message === 'string';
};
